/**
 * 来款记录列表
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/5/17      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react'
import {Table, Card, Button, Space} from "antd";
import dayjs from "dayjs";
import "./index.less";
import OtherConsignee from "../OtherConsignee/OtherConsignee";
import RetroactivePaymentSerivce from "@services/RetroactivePaymentSerivce";
import DetailOrder from "@components/DetailOrder/DetailOrder";
import {numberWithCommas, toFixedWithCommas} from "@utils/number-util";
import Lang from '@components/Lang/Lang';
import {Link} from "react-router-dom";

class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false
        }
    }

    /**
     * 更新催款时间
     */
    updateRetroactiveTime = (buyerId) => {
        RetroactivePaymentSerivce.updateRetroactiveTime({buyerId}).then(resp => {
            if (resp.data.success && resp.data.valid) {
                this.props.onChange();
            }
        })
    }

    /**
     *  获取表单头
     */
    getColumns() {
        let {extra} = this.props;
        return [
            {
                title: __getServerLanguage('DingDanXinXi'),
                width: 350,
                fixed: "left",
                key: "1",
                render: (text = {}, record, index) => (
                    <div key={index}>
                        <p className="font_13">{__getServerLanguage('PODanHao')} <DetailOrder poCode={text.orderNumber} poId={text.id}>{text.orderNumber}</DetailOrder></p>
                        <p className="font_12 mt_8">{__getServerLanguage('YuJiDaoGangShiJian')}：{text.arrivalPortDate ? dayjs(text.arrivalPortDate).format("YYYY-MM-DD HH:mm:ss") : ""}</p>
                    </div>
                ),
            },
            {
                title: __getServerLanguage('QuanBuZhuangTai'),
                key: "2",
                width: 200,
                render: (text = {}, record, index) => (
                    <div key={index}>
                        <span className="color-black font_13">{text.status}</span>
                        <p className="color-gray font_12">{text.changeStatusTime?dayjs(text.changeStatusTime).format("YYYY-MM-DD HH:mm:ss"):""}</p>
                    </div>
                ),
            },
            {
                title: __getServerLanguage('DingDanJinE'),
                key: "3",
                render: (text = {}, record, index) => (
                    <b className="color-black" key={index}>
                        {extra.currencySymbol} {numberWithCommas(toFixedWithCommas(text.priceTotal,2))}
                    </b>
                ),
            },
            {
                title: __getServerLanguage('DaiShouKuanJinE'),
                key: "4",
                render: (text = {}, record, index) => (
                    <b className="color-danger" key={index}>
                        {extra.currencySymbol} {numberWithCommas(toFixedWithCommas(text.todoPrice,2))}
                    </b>
                ),
            },
            {
                title: __getServerLanguage('ZuiChiFuKuanShiJian'),
                key: "5",
                width: 180,
                render: (text = {}, record, index) => (
                    <span className="color-black" key={index}>{text.lastPayTime?dayjs(text.lastPayTime).format("YYYY-MM-DD HH:mm:ss"):""}</span>
                ),
            },
        ];
    }
    /**
     * 处理收款收据
     * */
    handleInvoice(buyId){
        // todo 处理显示的前提
        console.log('handleInvoice',buyId)
    }
    render() {
        let columns = this.getColumns();
        let {list, extra} = this.props;
        return (
            <div className="retroactive-payment-list-wrap">
                {
                    list.map((item, index) => {
                        return <Card className="mb_16" key={index}>
                            <div className="mb_16" data-flex="main:justify">
                                <div>
                                    <p className="font_15 color-black"><b>{__getServerLanguage('KeHu')} {item.buyerNumber} </b></p>
                                    <p className="mt_8 color-gray">
                                        <OtherConsignee consignees={item.consigneeVOS}>
                                            <span>{item.email}</span>
                                            {
                                                item.mobile ?
                                                    <span className="ml_8">+{item.telCode} {item.mobile}</span>
                                                    :
                                                    null
                                            }
                                            <span className="iconfont ml_8 font_12 icon-jiantou-xia"></span>
                                        </OtherConsignee>
                                    </p>
                                </div>
                                <b className="font_16">
                                    <span className="color-black">{__getServerLanguage('HeJiYingShouKuan')}</span>
                                    <span className="color-danger"> {extra.currencySymbol} {numberWithCommas(toFixedWithCommas(item.todoPriceTotal,2))}</span>
                                </b>
                            </div>
                            <Table
                                rowKey="id"
                                sticky={true}
                                columns={columns}
                                pagination={false}
                                // scroll={{x: 1050}}
                                dataSource={item.balancePaymentVOS}
                            />
                            <div className="mt_16" data-flex="main:justify">
                                <div>
                                    {__getServerLanguage('ZuiJinCuiKuan')}：{item.urgeName || '-'} {item.urgeTime ? dayjs(item.urgeTime).format("YYYY-MM-DD HH:mm:ss") : ""}
                                </div>
                                <div>
                                    <Space>
                                        <Link
                                            className="link"
                                            target = "_blank"
                                            to={`/customer/invoice?id=${item.buyerId}`}>
                                            <Button>{Lang({id: 'ShouKuanShouJu',default:'收款收据'})}</Button>
                                        </Link>

                                    <Button onClick={this.updateRetroactiveTime.bind(this, item.buyerId)}>{__getServerLanguage('JiLuCuiKuanShiJian')}</Button>
                                    </Space>
                                </div>
                            </div>
                        </Card>
                    })
                }
            </div>

        )
    }
}

List.defaultProps = {
    list: [],
    extra: {}
}

List.propTypes = {}
export default List;
